import React from 'react';
import './Spinner.css';

const SIZE_PRESETS = {
  small: 18,
  medium: 32,
  large: 48,
};

/**
 * Shared loading spinner — consolidates the ad hoc `.spinner` /
 * `.loading-spinner` / `.notif-spinner` markup duplicated across
 * Buddy.css, Navbar.css, Feed.css, Messages.css, community/community.css
 * etc. Reuses the existing `.clay-spinner` keyframes/ring styling from
 * src/styles/clay-motion.css rather than inventing a new spinner look.
 *
 * <Spinner />                       — inline, medium
 * <Spinner size="small" />          — inline, small
 * <Spinner size={64} />             — inline, custom px size
 * <Spinner fullPage label="..." />  — centered in a full-height container, optional caption
 */
function Spinner({ size = 'medium', fullPage = false, label, className = '' }) {
  const px = typeof size === 'number' ? size : SIZE_PRESETS[size] || SIZE_PRESETS.medium;
  const spinner = (
    <span
      className={`ui-spinner clay-spinner ${className}`}
      style={{ width: px, height: px }}
      role="status"
      aria-label={label || 'Loading'}
    />
  );

  if (!fullPage) return spinner;

  return (
    <div className="ui-spinner-fullpage">
      {spinner}
      {label && <p className="ui-spinner-label">{label}</p>}
    </div>
  );
}

export default Spinner;
